<template>
  <div class="father">
    <div v-if="screenWidth >= 600" class="needback">
      <!-- <div class="bannerClass"></div> -->
      <h1>{{ news.title }}</h1>

      <div v-html="news.content" class="content"></div>
      <div class="right" v-if="news.source">
        来源：
        <span style="color: #576b95;">{{ news.source }}</span>
      </div>
    </div>

    <div v-else>
      <phone-news-detail />
    </div>
  </div>
</template>

<script>
import phoneNewsDetail from "./phone/phoneNewsDetail.vue";
export default {
  name: "product",
  components: { phoneNewsDetail },
  props: ["to"],
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          //console.log(this.screenWidth);
          this.timer = false;
        }, 400);
      }
    }
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      news: "",
      params: ""
    };
  },
  destroyed() {
    sessionStorage.clear();
  },
  mounted() {
    if (document.getElementById("main")) {
      document.getElementById("main").scroll(0, 0);
    }
    // var paramsData = sessionStorage.getItem("paramsData");
    //    if(paramsData){
    //         var params = JSON.parse(sessionStorage.getItem("paramsData"));
    //         this.news = params;
    //     }else{
    //         var params = this.to;
    //         sessionStorage.setItem("paramsData", this.to);
    //         this.news = JSON.parse(params);
    //     }

    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };

    this.params = this.$route.params.id.split(".")[0];

    this.getData();

  },
  // beforeRouteEnter (to, from, next) {
  //   next((vm) => {

  //     var paramsData = sessionStorage.getItem("paramsData");
  //      if(paramsData){
  //           var params = JSON.parse(sessionStorage.getItem("paramsData"));
  //           document.title = params.title +'【辰鳗科技】';
  //           document.querySelector('meta[name="description"]').setAttribute('content', params.title +'【辰鳗科技】')
  //       }else{
  //           var params = vm.to;
  //           sessionStorage.setItem("paramsData", vm.to);
  //           document.title = JSON.parse(params).title +'【辰鳗科技】';
  //           document.querySelector('meta[name="description"]').setAttribute('content', JSON.parse(params).title +'【辰鳗科技】')
  //       }
  //   });
  // },
  methods: {
    getData() {
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 1);
      params.append("aid", this.params);
      this.$axios.post("/api/websiteNews/websiteList", params).then(res => {
        this.news = res.data.data.records[0];
        document.title = this.news.title + "【辰鳗科技】";
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", this.news.title + "【辰鳗科技】");
      });
    }
  }
};
</script>

<style scoped lang="scss">
.father{
  display: flex;
  align-items: center;
  justify-content: center;
}
.needback{
  font-size: 16px;
    width: 1000px;
    padding: 40px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
    border-radius: 8px;
    min-height: 230px;
    margin: 20px;

}
h1 {
  width: 880px;
  margin: 20px auto;
  white-space: wrap;
  text-align: left;
  padding-bottom: 30px;
}
.right {
  text-align: right;
  width: 880px;
  margin: 20px auto 100px;
  font-size: 14px;
}
.bannerClass {
  width: 100%;
  color: #ffffff;
  height: 580px;
  background-image: url("../../assets/news/zy1.png");
  background-position: center;
  background-size: cover;
}
.content {
  text-indent: 0 !important;
  min-height: 18px;
  width: 880px;
  margin: auto;
  font-size: 18px;
  color: #0d141e;
  line-height: 1.6667;
  word-wrap: break-word;
  font-family: PingFangSC-Regular;
  text-align: justify;
  letter-spacing: 2px;
  >>> p {
    line-height: 28px;
  }

  >>> p > img {
    width: 100% !important;
    height: 50% !important;
  }
}
</style>
<style>
.ql-align-center {
  text-align: center;
}
.ql-align-left {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/page/newDetail.vue